module.exports = __webpack_public_path__ + "static/media/VAC-dark.aa7b4c13.webp";